/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import {
  AddMemberForm,
  Feedbacktext,
  InputLabel,
  InputWrapper,
  PopupInput,
  UpdateButton,
} from './addReferrerElements';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate';

const AddWaitlistPopup = ({
  setOpen, setData,
}) => {
  const axiosPrivate = useAxiosPrivate();

  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [name, setName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name) {
      return setFeedback('Name cant be empty');
    }

    setLoading(true);

    axiosPrivate.post(
      '/addReferrer',
      JSON.stringify({
        name,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status === 'error') {
        setLoading(false);
        setFeedback(res.data.message ? res.data.message : 'Something went wrong');
        setName('');
      } else {
        setFeedback(res.data.message);
        setData((prev) => [
          ...prev,
          {
            Name: name,
            ID: res.data.id,
          },
        ]);
        setName('');
        setTimeout(() => {
          setLoading(false);
          setOpen(false);
          setFeedback('');
        }, 1000);
      }
    }).catch((error) => {
      setLoading(false);
      setFeedback(error.response.data.message ? error.response.data.message : 'Something went wrong');
      setName('');
    });
  };

  // Error handling
  useEffect(() => {
    if (name) { setFeedback(''); }
  }, [name]);

  return (
    <AddMemberForm onSubmit={handleSubmit}>
      <InputWrapper>
        <InputLabel htmlFor="name">Name:</InputLabel>
        <PopupInput
          value={name}
          autoComplete="off"
          onChange={(e) => setName(e.target.value)}
          type="text"
          name="name"
        />
      </InputWrapper>
      <UpdateButton disabled={loading} type="submit">{loading ? 'Adding referrer' : 'Add referrer'}</UpdateButton>
      {feedback && <Feedbacktext>{feedback}</Feedbacktext>}
    </AddMemberForm>
  );
};

export default AddWaitlistPopup;
